import { actionTypes } from 'actions/actionTypes'
import type { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const clearGoustoRef: CheckoutActionCreator = () => async (dispatch) => {
  dispatch({
    type: actionTypes.CHECKOUT_SET_GOUSTO_REF,
    goustoRef: null,
  })
}
